<template>
  <main class="main main--full-height main--connexion">
    <div class="box box--connexion">
      <form class="form">
        <ButtonElement color="bordeaux" :icon="PhFingerprint" @click="logIn"
          >Me connecter</ButtonElement
        >
        <router-link :to="{ name: 'inscription' }" custom v-slot="{ navigate }">
          <ButtonElement color="bordeaux" bordered :icon="PhSignIn" @click="navigate"
            >Première connexion</ButtonElement
          >
        </router-link>
      </form>
    </div>
  </main>
</template>

<script setup lang="ts">
import { PhFingerprint, PhSignIn } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import { useUserStore } from '@/stores/user.ts'
import { useRouter } from 'vue-router'
import { useLoadingStore } from '@/stores/loading.ts'

const userStore = useUserStore()
const loadingStore = useLoadingStore()
const router = useRouter()

async function logIn() {
  loadingStore.start()
  try {
    await userStore.logIn()
    await router.push({ name: 'accueil' })
  } finally {
    loadingStore.stop()
  }
}
</script>
